import { render, staticRenderFns } from "./BotonesCompra.vue?vue&type=template&id=fd304e6c&scoped=true"
import script from "./BotonesCompra.vue?vue&type=script&lang=js"
export * from "./BotonesCompra.vue?vue&type=script&lang=js"
import style0 from "./BotonesCompra.vue?vue&type=style&index=0&id=fd304e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd304e6c",
  null
  
)

export default component.exports